import React, { useState, useEffect, useContext } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Table } from 'reactstrap';
import ViaticosPlanillaService from '../../axios_services/viaticos_planilla.service';
import Loader from '../Loader/Loader';
import { AppContext } from '../../application/provider';

const ModalDetallePlanillaViatico = ({ isOpen, onClose, solicitudId }) => {
    const [state] = useContext(AppContext);
    const [planilla, setPlanilla] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isOpen && solicitudId) {
            fetchDetalle();
        }
    }, [isOpen, solicitudId]);

    const fetchDetalle = async () => {
        setLoading(true);
        try {
            const res = await ViaticosPlanillaService.getPlanillas();
            const found = (res.data || []).find(p => p.solicitud_id === solicitudId);
            setPlanilla(found || null);
        } catch (error) {
            console.error('Error fetching planilla', error);
        } finally {
            setLoading(false);
        }
    };

    const formatoSoles = (monto) => {
        return new Intl.NumberFormat('es-PE', {
            style: 'currency',
            currency: 'PEN',
        }).format(monto || 0);
    };

    return (
        <Modal isOpen={isOpen} toggle={onClose} className="custom-modal" size="lg">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>DETALLE DE PLANILLA DE VIÁTICOS</h1>
                    <Button className="close-btn" onClick={onClose}>X</Button>
                </div>
            </ModalHeader>
            <ModalBody className="modal-body" style={{ color: '#333', fontSize: '14px' }}>
                {loading ? (
                    <Loader />
                ) : planilla ? (
                    <div style={{ padding: '10px 20px 30px 20px' }}>
                        <div className="table-container" style={{ margin: '0' }}>
                            <Table bordered size="sm">
                                <thead style={{ backgroundColor: '#f3f4f6' }}>
                                    <tr>
                                        <th style={{ textAlign: 'center' }}>CONCEPTO</th>
                                        <th style={{ textAlign: 'center' }}>MONTO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{`TRANSPORTE${planilla.lugar ? `: ${planilla.lugar.toUpperCase()}` : ''}`}</td>
                                        <td style={{ textAlign: 'right' }}>{formatoSoles(planilla.monto_pasaje)}</td>
                                    </tr>
                                    <tr>
                                        <td>HOSPEDAJE</td>
                                        <td style={{ textAlign: 'right' }}>{formatoSoles(planilla.monto_hospedaje)}</td>
                                    </tr>
                                    <tr>
                                        <td>MOVILIDAD LOCAL</td>
                                        <td style={{ textAlign: 'right' }}>{formatoSoles(planilla.monto_movilidad)}</td>
                                    </tr>
                                    <tr>
                                        <td>ALIMENTACIÓN</td>
                                        <td style={{ textAlign: 'right' }}>{formatoSoles(planilla.monto_alimentacion)}</td>
                                    </tr>
                                    <tr>
                                        <td>ADICIONAL</td>
                                        <td style={{ textAlign: 'right' }}>{formatoSoles(planilla.monto_adicional)}</td>
                                    </tr>
                                    <tr style={{ fontWeight: 'bold', backgroundColor: '#f9fafb' }}>
                                        <td style={{ textAlign: 'center' }}>TOTAL</td>
                                        <td style={{ textAlign: 'right' }}>
                                            {formatoSoles(
                                                (Number(planilla.monto_pasaje) || 0) +
                                                (Number(planilla.monto_hospedaje) || 0) +
                                                (Number(planilla.monto_movilidad) || 0) +
                                                (Number(planilla.monto_alimentacion) || 0) +
                                                (Number(planilla.monto_adicional) || 0)
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </div>
                ) : (
                    <div className="text-center p-4">No se encontraron detalles de la planilla.</div>
                )}
            </ModalBody>
        </Modal>
    );
};

export default ModalDetallePlanillaViatico;
